"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var context_1 = require("./context");
var admin_styles_1 = __importDefault(require("./admin-styles"));
var utils_1 = require("../store/utils");
function FlaggAdmin(_a) {
    var onDone = _a.onDone;
    var _b = react_1.useState(''), searchTerm = _b[0], setSearchTerm = _b[1];
    var ff = react_1.useContext(context_1.FlaggContext).featureFlags;
    var definitions = getSortedDefinitions(ff.getDefinitions(), searchTerm.toLowerCase().trim());
    var shareUrl = window.location.href + "?ff=" + encodeURIComponent(JSON.stringify(ff.getAllOverridden()));
    var reset = function () {
        Object.entries(ff.getDefinitions()).forEach(function (_a) {
            var flagName = _a[0], flagDef = _a[1];
            ff.set(flagName, ff.getDefault(flagName));
        });
    };
    return (react_1.default.createElement("div", { className: "flagg" },
        react_1.default.createElement("style", null, admin_styles_1.default),
        react_1.default.createElement("div", { className: "flagg-header" },
            react_1.default.createElement("div", { className: "flagg-header__lead" },
                react_1.default.createElement("span", { className: "flagg-header__name" },
                    react_1.default.createElement(Icon, { icon: "flag" }),
                    react_1.default.createElement("span", null, "Flagg"))),
            react_1.default.createElement("div", { className: "flagg-header__end" },
                react_1.default.createElement("button", { title: "Copy URL", className: "flagg-button", onClick: function () { return navigator.clipboard.writeText(shareUrl); } },
                    react_1.default.createElement(Icon, { icon: "link" })),
                react_1.default.createElement("button", { className: "flagg-button", onClick: reset, title: "Reset" },
                    react_1.default.createElement(Icon, { icon: "refresh" })),
                onDone && (react_1.default.createElement("button", { className: "flagg-button", onClick: onDone },
                    react_1.default.createElement(Icon, { icon: "checkCircle" }))))),
        react_1.default.createElement("div", { className: "flagg-categories" },
            react_1.default.createElement("div", { className: "flagg-category flagg-category--search" },
                react_1.default.createElement(Icon, { icon: "search" }),
                react_1.default.createElement("input", { value: searchTerm, onChange: function (evt) { return setSearchTerm(evt.currentTarget.value); }, className: "flagg-search", type: "search", placeholder: "Search Feature Flags" })),
            !definitions.length && (react_1.default.createElement("div", { className: "flagg-zero" }, "Nothing to see here...")),
            definitions.map(function (_a) {
                var categoryName = _a.categoryName, values = _a.values;
                return (react_1.default.createElement("div", { key: categoryName, className: "flagg-category" },
                    react_1.default.createElement("div", { className: "flagg-category__name" }, categoryName || 'Flags'),
                    values.map(function (_a) {
                        var flagName = _a.flagName, name = _a.name, definition = _a.definition;
                        return (react_1.default.createElement(Flag, { key: flagName, name: name, categoryName: categoryName, flagName: flagName, definition: definition, ff: ff }));
                    })));
            })),
        react_1.default.createElement(Footer, null)));
}
exports.FlaggAdmin = FlaggAdmin;
function Footer() {
    return (react_1.default.createElement("div", { className: "flagg-footer" },
        "Made with \u2764\uFE0F in Sunny FL \u00B7",
        ' ',
        react_1.default.createElement("a", { href: "https://github.com/jamesmfriedman/flagg" }, "Visit Github")));
}
var iconPaths = {
    flag: 'M14.4 6L14 4H5v17h2v-7h5.6l.4 2h7V6z',
    search: 'M7,0 C3.1458514,0 0,3.1458514 0,7 C0,10.854149 3.1458514,14 7,14 C8.747998,14 10.345009,13.348024 11.574219,12.28125 L12,12.707031 L12,14 L18,20 L20,18 L14,12 L12.707031,12 L12.28125,11.574219 C13.348024,10.345009 14,8.747998 14,7 C14,3.1458514 10.854149,0 7,0 Z M7,2 C9.773268,2 12,4.2267316 12,7 C12,9.773268 9.773268,12 7,12 C4.2267316,12 2,9.773268 2,7 C2,4.2267316 4.2267316,2 7,2 Z',
    refresh: 'M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z',
    checkCircle: 'M16.59 7.58L10 14.17l-3.59-3.58L5 12l5 5 8-8zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z',
    link: 'M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z',
    snowflake: 'M20.79,13.95L18.46,14.57L16.46,13.44V10.56L18.46,9.43L20.79,10.05L21.31,8.12L19.54,7.65L20,5.88L18.07,5.36L17.45,7.69L15.45,8.82L13,7.38V5.12L14.71,3.41L13.29,2L12,3.29L10.71,2L9.29,3.41L11,5.12V7.38L8.5,8.82L6.5,7.69L5.92,5.36L4,5.88L4.47,7.65L2.7,8.12L3.22,10.05L5.55,9.43L7.55,10.56V13.45L5.55,14.58L3.22,13.96L2.7,15.89L4.47,16.36L4,18.12L5.93,18.64L6.55,16.31L8.55,15.18L11,16.62V18.88L9.29,20.59L10.71,22L12,20.71L13.29,22L14.7,20.59L13,18.88V16.62L15.5,15.17L17.5,16.3L18.12,18.63L20,18.12L19.53,16.35L21.3,15.88L20.79,13.95M9.5,10.56L12,9.11L14.5,10.56V13.44L12,14.89L9.5,13.44V10.56Z'
};
function Icon(_a) {
    var icon = _a.icon, props = __rest(_a, ["icon"]);
    var path = iconPaths[icon];
    return (react_1.default.createElement("svg", __assign({ width: "24", height: "24", viewBox: "0 0 24 24" }, props, { className: "flagg-" + icon + "-icon" }),
        react_1.default.createElement("path", { fill: "currentColor", d: path })));
}
function Flag(_a) {
    var definition = _a.definition, flagName = _a.flagName, name = _a.name, ff = _a.ff, categoryName = _a.categoryName;
    var control = null;
    var controlType = getControlType(definition);
    var isOverride = ff.isOverridden(flagName);
    var isFrozen = ff.isFrozen(flagName);
    switch (controlType) {
        case 'select':
            control = (react_1.default.createElement(Select, { value: ff.get(flagName), options: definition.options, defaultValue: definition.default, onChange: function (evt) {
                    return ff.set(flagName, evt.currentTarget.value === ''
                        ? definition.default
                        : evt.currentTarget.value);
                } }));
            break;
        case 'input':
            control = (react_1.default.createElement(Input, { value: ff.get(flagName), onChange: function (evt) { return ff.set(flagName, evt.currentTarget.value); } }));
            break;
        case 'toggle':
        default:
            control = react_1.default.createElement(Toggle, { checked: !!ff.get(flagName), onChange: function () { } });
    }
    return (react_1.default.createElement("div", { key: flagName, className: [
            'flagg-flag',
            isOverride && 'flagg-flag--override',
            isFrozen && 'flagg-flag--frozen'
        ]
            .filter(Boolean)
            .join(' '), onClick: controlType === 'toggle'
            ? function () { return ff.set(flagName, !ff.get(flagName)); }
            : undefined },
        isFrozen && react_1.default.createElement(Icon, { icon: "snowflake" }),
        !isFrozen && (react_1.default.createElement(Icon, { icon: "flag", onClick: function (evt) {
                evt.stopPropagation();
                ff.set(flagName, ff.getDefault(flagName));
            } })),
        react_1.default.createElement("div", null,
            react_1.default.createElement("div", { className: "flagg-flag__name" },
                react_1.default.createElement("span", { className: "flagg-flag__flag-name" }, definition.name || name)),
            (!!definition.description || definition.default !== undefined) && (react_1.default.createElement("div", { className: "flagg-flag__description" }, definition.description))),
        react_1.default.createElement("div", { title: flagName + ' - Default: ' + String(ff.getDefault(flagName)), className: ['flagg-control'].filter(Boolean).join(' ') }, control)));
}
function Toggle(_a) {
    var props = __rest(_a, []);
    return react_1.default.createElement("input", __assign({ type: "checkbox", className: "flagg-toggle" }, props));
}
function Input(_a) {
    var props = __rest(_a, []);
    return react_1.default.createElement("input", __assign({ type: "text", className: "flagg-input" }, props));
}
function Select(_a) {
    var options = _a.options, defaultValue = _a.defaultValue, value = _a.value, props = __rest(_a, ["options", "defaultValue", "value"]);
    return (react_1.default.createElement("select", __assign({ className: "flagg-select", value: value || '' }, props),
        !defaultValue && react_1.default.createElement("option", { value: '' }, "-- OFF --"),
        options.map(function (option) { return (react_1.default.createElement("option", { key: option, value: option }, option)); })));
}
var getControlType = function (definition) {
    if (definition.options) {
        return 'select';
    }
    if (typeof definition.default === 'string') {
        return 'input';
    }
    return 'toggle';
};
var getSortedDefinitions = function (definitions, searchTerm) {
    var defsMap = Object.entries(definitions).reduce(function (acc, _a) {
        var flagName = _a[0], flagDef = _a[1];
        var parts = flagName.split(utils_1.KEY_DELIMETER, 2);
        var category = parts.length > 1 ? parts[0] : '';
        var name = parts.pop();
        acc[category] = acc[category] || [];
        var shouldAdd = !searchTerm ||
            flagName.toLowerCase().includes(searchTerm) ||
            (flagDef.name || '').toLowerCase().includes(searchTerm) ||
            (flagDef.description || '').toLowerCase().includes(searchTerm);
        shouldAdd &&
            acc[category].push({
                flagName: flagName,
                name: name,
                definition: flagDef
            });
        return acc;
    }, {});
    return Object.entries(defsMap)
        .filter(function (_a) {
        var values = _a[1];
        return values.length;
    })
        .map(function (_a) {
        var categoryName = _a[0], values = _a[1];
        return {
            categoryName: categoryName,
            values: values.sort(function (a, b) { return (a.name > b.name ? 1 : -1); })
        };
    })
        .sort(function (a, b) { return (a.categoryName > b.categoryName ? 1 : -1); });
};
//# sourceMappingURL=admin.js.map